import logo from "../images/logo.png";

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => scrollToSection("hero")}
          >
            <img
              src={logo}
              alt="Kadernícky salón Katka logo"
              className="h-20 md:h-24 object-contain"
            />
            <span
              className={`text-xl font-semibold transition-colors ${
                isScrolled ? "text-gray-900" : "text-white"
              }`}
            >
              Kadernícky salón Katka
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection("sluzby")}
              className={`text-sm font-medium transition-colors hover:text-amber-700 whitespace-nowrap ${
                isScrolled ? "text-gray-700" : "text-white"
              }`}
            >
              Služby
            </button>
            <button
              onClick={() => scrollToSection("galeria")}
              className={`text-sm font-medium transition-colors hover:text-amber-700 whitespace-nowrap ${
                isScrolled ? "text-gray-700" : "text-white"
              }`}
            >
              Galéria
            </button>
            <button
              onClick={() => scrollToSection("o-nas")}
              className={`text-sm font-medium transition-colors hover:text-amber-700 whitespace-nowrap ${
                isScrolled ? "text-gray-700" : "text-white"
              }`}
            >
              O nás
            </button>
            <button
              onClick={() => scrollToSection("kontakt")}
              className={`text-sm font-medium transition-colors hover:text-amber-700 whitespace-nowrap ${
                isScrolled ? "text-gray-700" : "text-white"
              }`}
            >
              Kontakt
            </button>
            <button
              onClick={() => scrollToSection("kontakt")}
              className="bg-amber-700 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-amber-800 transition-colors whitespace-nowrap"
            >
              Objednať sa
            </button>
          </div>

          <button
            onClick={() => scrollToSection("kontakt")}
            className="md:hidden bg-amber-700 text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-amber-800 transition-colors whitespace-nowrap"
          >
            Objednať
          </button>
        </div>
      </div>
    </nav>
  );
}
